export const mapToDictArr = (data: string[], dictKey: string) => {
    return data.reduce(
        (acc: Record<string, string>[], cur: string) => {
            return [...acc, { [dictKey]: cur }]
        }, [])
}
